import React, { useEffect, useState } from "react";
import { useMsal } from "@azure/msal-react";

// Entra ID names come as "Last, First": the initials are first name + first last name
const initials = (name) => {
  const [last, first] = (name || "?").split(",").map((part) => part.trim().split(/\s+/)[0] || "");
  const letters = first ? [first, last] : (name || "?").trim().split(/\s+/).slice(0, 2);
  return letters.map((part) => (part[0] || "").toUpperCase()).join("");
};

// Photo of the signed-in user from Microsoft Graph. Silent only: without a photo or consent, the initials are shown
export default function ProfilePhoto({ size = 32 }) {
  const { instance, accounts } = useMsal();
  const account = accounts[0];
  const [photo, setPhoto] = useState(null);

  useEffect(() => {
    if (!account) return undefined;
    let url = null;
    let cancelled = false;
    const load = async () => {
      try {
        const { accessToken } = await instance.acquireTokenSilent({ account, scopes: ["User.Read"] });
        const response = await fetch("https://graph.microsoft.com/v1.0/me/photos/96x96/$value", {
          headers: { Authorization: `Bearer ${accessToken}` },
        });
        if (!response.ok || cancelled) return;
        url = URL.createObjectURL(await response.blob());
        setPhoto(url);
      } catch {
        // Initials are shown instead
      }
    };
    load();
    return () => {
      cancelled = true;
      if (url) URL.revokeObjectURL(url);
    };
  }, [instance, account]);

  if (!account) return null;

  return photo ? (
    <img className="profile-photo" src={photo} alt="" width={size} height={size} />
  ) : (
    <span className="profile-photo profile-photo--initials" style={{ width: size, height: size }} aria-hidden="true">
      {initials(account.name || account.username)}
    </span>
  );
}
